import type { SVGProps } from 'react'
const SvgSyUnlock = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M12.123 1.75a5.31 5.31 0 0 0-5.32 5.277v2.17a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V7.031a3.79 3.79 0 0 1 3.816-3.781h.004c1.67 0 3.077 1.07 3.592 2.557a.75.75 0 0 0 .955.464.75.75 0 0 0 .463-.955 5.31 5.31 0 0 0-5.008-3.566z"
				opacity={0.4}
			/>
			<path
				fillRule="evenodd"
				d="M8.293 8.377A4.555 4.555 0 0 0 3.75 12.92v4.287c0 2.5 2.044 4.543 4.543 4.543h7.64c2.5 0 4.542-2.043 4.542-4.543V12.92c0-2.5-2.042-4.543-4.541-4.543zm0 1.5h7.64a3.03 3.03 0 0 1 3.042 3.043v4.287a3.03 3.03 0 0 1-3.041 3.043H8.293a3.03 3.03 0 0 1-3.043-3.043V12.92a3.03 3.03 0 0 1 3.043-3.043"
				clipRule="evenodd"
			/>
			<path d="M12.113 13.203a.75.75 0 0 0-.75.75v2.22a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-2.22a.75.75 0 0 0-.75-.75" />
		</g>
	</svg>
)
export default SvgSyUnlock
